"use client";
import { useState, useCallback } from "react";

/**
 * Manages modal open/close state.
 * Returns a boolean state and a toggle function.
 */
export function useModal() {
  const [isOpen, setIsOpen] = useState(false);

  // Toggles modal visibility
  const toggleModal = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return { isOpen, toggleModal };
}
